module.exports = __webpack_public_path__ + "static/media/logo-mst.9423f075.svg";